// wait document ready
document.addEventListener("DOMContentLoaded", () => {
  const isSingle = document.querySelector(".main-product__details");
  if (!isSingle) {
    return;
  }

  const select = isSingle.querySelectorAll("select");

  select.forEach((element) => {
    var example = new Choices(element, {
      searchEnabled: false,
      itemSelectText: "",
    });
    example.itemList.element.querySelectorAll('.choices__item--selectable').forEach((item) => {
      item.setAttribute("role", "option");
    });
    example.containerOuter.element.setAttribute("aria-label", "Select");
  });
});
